import {
  CButton,
  CBadge,
  CDropdown,
  CDropdownToggle,
  CDropdownMenu,
  CDropdownItem,
  CSmartTable,
} from '@coreui/react-pro'
import CIcon from '@coreui/icons-react'
import { cilOptions, cilTrash, cilInputPower } from '@coreui/icons'
import React, { useEffect, useState } from 'react'
import Loader from 'src/components/Loader'
import PlayerService from 'src/service/PlayerService'
import Bootbox from 'bootbox-react'
import ToastComponent from 'src/components/common/TaostComponent'

const columns = [
  { label: 'Player', key: 'full_name', filter: false },
  { label: 'Position', key: 'position_name', filter: false },
  { label: 'Value', key: 'svalue', filter: false },
  { label: 'Status', key: 'is_active', filter: false, sorter: false },
  { key: 'actions', label: 'Actions', filter: false, sorter: false },
]

const InactivePlayer = () => {
  const [loading, setLoading] = useState(false)
  const [users, setUsers] = useState([])
  const [selectedItems, setSelectedItems] = useState([])

  useEffect(() => {
    fetchData()
  }, [])

  const fetchData = () => {
    setLoading(true)
    PlayerService.inActivePlayer().then((result) => {
      setUsers(result.data)
      setSelectedItems([])
      setLoading(false)
    })
  }

  const selectedIds = selectedItems.map((item) => item.id)

  // Single delete
  const [showConfirm, setShowConfirm] = useState(false)
  const [recordId, setRecordId] = useState(null)
  const showConfirmBox = (id) => {
    setRecordId(id)
    setShowConfirm(true)
  }
  const handleConfirm = () => {
    setShowConfirm(false)
    PlayerService.deletePlayer({ id: recordId }).then((res) => {
      if (res.status === 200) {
        ToastComponent(res.message, 'success')
        fetchData()
      }
    })
  }

  // Single status change
  const [showStatusConfirm, setShowStatusConfirm] = useState(false)
  const [statusRecordId, setStatusRecordId] = useState(null)
  const [statusValue, setStatusValue] = useState(null)
  const showStatusConfirmBox = (id, status) => {
    setStatusRecordId(id)
    setStatusValue(status)
    setShowStatusConfirm(true)
  }
  const handleStatusConfirm = () => {
    setShowStatusConfirm(false)
    PlayerService.deActiveAllPlayer({ playerIds: [statusRecordId], status: statusValue }).then(
      (res) => {
        if (res.status === 200) {
          ToastComponent(res.message, 'success')
          fetchData()
        }
      },
    )
  }

  // Bulk delete
  const [showBulkDeleteConfirm, setShowBulkDeleteConfirm] = useState(false)
  const handleBulkDeleteConfirm = () => {
    setShowBulkDeleteConfirm(false)
    PlayerService.deleteAllPlayer({ playerIds: selectedIds }).then((res) => {
      if (res.status === 200) {
        ToastComponent(res.message, 'success')
        fetchData()
      }
    })
  }

  // Bulk status change
  const [showBulkStatusConfirm, setShowBulkStatusConfirm] = useState(false)
  const [bulkStatusValue, setBulkStatusValue] = useState(null)
  const showBulkStatusConfirmBox = (status) => {
    setBulkStatusValue(status)
    setShowBulkStatusConfirm(true)
  }
  const handleBulkStatusConfirm = () => {
    setShowBulkStatusConfirm(false)
    PlayerService.deActiveAllPlayer({ playerIds: selectedIds, status: bulkStatusValue }).then(
      (res) => {
        if (res.status === 200) {
          ToastComponent(res.message, 'success')
          fetchData()
        }
      },
    )
  }

  if (loading) return <Loader />

  return (
    <>
      <div className="d-flex flex-wrap align-items-center gap-2 mb-3 p-2 bg-light rounded-2">
        <div className="fw-semibold ms-1 me-2">
          {selectedItems.length} player{selectedItems.length !== 1 ? 's' : ''} selected
        </div>
        <CButton
          color="danger"
          variant="outline"
          size="sm"
          disabled={selectedItems.length === 0}
          onClick={() => setShowBulkDeleteConfirm(true)}
        >
          <CIcon icon={cilTrash} className="me-1" />
          Delete Selected
        </CButton>
        <CButton
          color="warning"
          variant="outline"
          size="sm"
          disabled={selectedItems.length === 0}
          onClick={() => showBulkStatusConfirmBox(0)}
        >
          <CIcon icon={cilInputPower} className="me-1" />
          Deactivate Selected
        </CButton>
        <CButton
          color="success"
          variant="outline"
          size="sm"
          disabled={selectedItems.length === 0}
          onClick={() => showBulkStatusConfirmBox(1)}
        >
          <CIcon icon={cilInputPower} className="me-1" />
          Activate Selected
        </CButton>
      </div>

      <div className="ge-datatable ge-datatable--static">
        <CSmartTable
          columns={columns}
          selectable
          selected={selectedItems}
          onSelectedItemsChange={setSelectedItems}
          scopedColumns={{
            full_name: (item) => {
              const imgSrc =
                item?.is_avatar === 1
                  ? `${process.env.REACT_APP_PLAYER_AVATAR_URL}${item.image}`
                  : `${process.env.REACT_APP_API_URL}uploads/player/${item.image}`
              return (
                <td>
                  <div className="d-flex align-items-center">
                    <img
                      src={imgSrc}
                      alt="img"
                      width="40"
                      height="40"
                      className="rounded-circle me-2"
                    />
                    <div>
                      <div className="fw-semibold">{item.full_name}</div>
                      <div className="text-medium-emphasis small">{item.id}</div>
                    </div>
                  </div>
                </td>
              )
            },
            svalue: (item) => <td>${item.svalue}m</td>,
            position_name: (item) => <td>{item?.position_name || '—'}</td>,
            is_active: () => (
              <td>
                <CBadge color="danger">Not In Use</CBadge>
              </td>
            ),
            actions: (item) => (
              <td className="py-2">
                <CDropdown alignment="end">
                  <CDropdownToggle color="transparent" caret={false} className="p-0">
                    <CIcon icon={cilOptions} role="button" />
                  </CDropdownToggle>
                  <CDropdownMenu>
                    {item.is_active === 1 ? (
                      <CDropdownItem role="button" onClick={() => showStatusConfirmBox(item.id, 0)}>
                        <CIcon icon={cilInputPower} className="me-2" />
                        Deactivate
                      </CDropdownItem>
                    ) : (
                      <CDropdownItem role="button" onClick={() => showStatusConfirmBox(item.id, 1)}>
                        <CIcon icon={cilInputPower} className="me-2" />
                        Activate
                      </CDropdownItem>
                    )}
                    <CDropdownItem
                      role="button"
                      className="text-danger"
                      onClick={() => showConfirmBox(item.id)}
                    >
                      <CIcon icon={cilTrash} className="me-2" />
                      Delete
                    </CDropdownItem>
                  </CDropdownMenu>
                </CDropdown>
              </td>
            ),
          }}
          items={users}
          itemsPerPage={10}
          itemsPerPageSelect
          pagination
          tableProps={{ hover: true, responsive: true, className: 'align-middle mb-0' }}
        />
      </div>

      <Bootbox
        show={showConfirm}
        type={'confirm'}
        message={'Are you sure you want to delete this?'}
        onSuccess={handleConfirm}
        onCancel={() => setShowConfirm(false)}
        onClose={() => setShowConfirm(false)}
      />
      <Bootbox
        show={showStatusConfirm}
        type={'confirm'}
        message={'Are you sure you want to change player status?'}
        onSuccess={handleStatusConfirm}
        onCancel={() => setShowStatusConfirm(false)}
        onClose={() => setShowStatusConfirm(false)}
      />
      <Bootbox
        show={showBulkDeleteConfirm}
        type={'confirm'}
        message={`Are you sure you want to delete ${selectedIds.length} selected player${
          selectedIds.length !== 1 ? 's' : ''
        }?`}
        onSuccess={handleBulkDeleteConfirm}
        onCancel={() => setShowBulkDeleteConfirm(false)}
        onClose={() => setShowBulkDeleteConfirm(false)}
      />
      <Bootbox
        show={showBulkStatusConfirm}
        type={'confirm'}
        message={'Are you sure you want to change status for the selected players?'}
        onSuccess={handleBulkStatusConfirm}
        onCancel={() => setShowBulkStatusConfirm(false)}
        onClose={() => setShowBulkStatusConfirm(false)}
      />
    </>
  )
}

export default InactivePlayer
